export default __webpack_public_path__ + "static/program-3f38acc570481459f2130a1d5072b111.png";